<div class="auth h-100" id="layoutAuthentication">
	<div id="layoutAuthentication_content">
		<main><ng-content></ng-content></main>
	</div>
	<div id="layoutAuthentication_footer">
		<sb-footer [dark]="true"></sb-footer>
	</div>
</div>
